import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import ApiDocsPanel from '../utilities/ApiDocsPanel';
import '../../styles/_businessMessageForm.scss';
import { getWhatsAppApiExamples } from '../utilities/utilities/WhatsAppApiExamples';

const BusinessMessageForm = ({ phoneNumber, boundPhone, onSubmit, onBack, onSkip, isLoading }) => {
  const [formData, setFormData] = useState({
    from: phoneNumber,
    to: boundPhone,
    template: 'hello_world',
    body: '',
  });

  const templateOptions = [{ value: 'hello_world', label: 'Hello World' }];

  const businessMessageCodeExamples = getWhatsAppApiExamples(
    'template',
    formData.to,
    'your_whatsapp_phone_id'
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="business-message-form">
      <h3 className="form-title">Send a business-initiated message</h3>
      <p className="form-description">
        In this step, you can initiate a conversation with your users as a business.
        Business-initiated conversations require the use of pre-approved templates until the user
        responds. Select one of our pre-approved templates to start the conversation. After your
        customers reply, you can send free-form messages for up to 24 hours.
      </p>

      <Row>
        <Col md={4}>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>To</Form.Label>
              <Form.Control
                type="text"
                name="to"
                value={formData.to}
                onChange={handleChange}
                disabled
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>From</Form.Label>
              <Form.Control
                type="text"
                name="from"
                value={formData.from}
                onChange={handleChange}
                disabled
                className="disabled-input"
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Message Template</Form.Label>
              <Form.Control
                as="select"
                name="template"
                value={formData.template}
                onChange={handleChange}
              >
                {templateOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group className="mb-4 d-flex justify-content-between">
              <Button variant="ghost" className="back-btn" onClick={onBack} disabled={isLoading}>
                Back
              </Button>
              <div className="d-flex gap-2">
                <Button variant="ghost" onClick={onSkip} disabled={isLoading}>
                  Skip this step
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  className="send-template-btn"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Sending...
                    </>
                  ) : (
                    'Send template message'
                  )}
                </Button>
              </div>
            </Form.Group>
          </Form>
        </Col>
        <Col md={8}>
          <ApiDocsPanel codeExamples={businessMessageCodeExamples} />
        </Col>
      </Row>
    </div>
  );
};

BusinessMessageForm.propTypes = {
  phoneNumber: PropTypes.string.isRequired,
  boundPhone: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

BusinessMessageForm.defaultProps = {
  boundPhone: '',
  isLoading: false,
};

export default BusinessMessageForm;
